import { combineReducers } from 'redux';

import { RESET_DATE_FILTERS, SET_REPORTS_END_DATE_ISO, SET_REPORTS_START_DATE_ISO } from '../constants';
import valueReducer from '../../../common/reducers/valueReducer';

const startDate = valueReducer(null, SET_REPORTS_START_DATE_ISO, RESET_DATE_FILTERS);
const endDate = valueReducer(null, SET_REPORTS_END_DATE_ISO, RESET_DATE_FILTERS);

const reducer = combineReducers({
  startDate,
  endDate,
});

export default reducer;
